
define('tpl!taoQtiItem/qtiCreator/tpl/forms/response/pairScoreForm', ['handlebars'], function(hb){ 
return hb.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, functionType="function", self=this, escapeExpression=this.escapeExpression, helperMissing=helpers.helperMissing;

function program1(depth0,data) {
  
  
  return "style=\"display:block\"";
  }

function program3(depth0,data) {
  
  
  return " checked=\"checked\"";
  }

function program5(depth0,data) {
  
  
  return "data-default=\"true\"";
  }

  buffer += "<div class=\"grid-row\">\n    <div class=\"col-4\">\n       ";
  if (helper = helpers.left) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.left); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    </div>\n    <div class=\"col-3\">\n       ";
  if (helper = helpers.right) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.right); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    </div>\n    \n    <div class=\"col-2\" data-edit=\"correct\" ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.defineCorrect), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += ">\n        <label>\n            <input name=\"";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "-correct\" type=\"checkbox\" ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.correct), {hash:{},inverse:self.noop,fn:self.program(3, program3, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += " />\n            <span class=\"icon-checkbox\"></span>\n        </label>\n    </div>\n\n    <div class=\"col-2\">\n        <input type=\"text\" \n               value=\"";
  if (helper = helpers.score) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.score); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" \n               name=\"";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "-score\" \n               class=\"score\" \n               ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.defaultScore), {hash:{},inverse:self.noop,fn:self.program(5, program5, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "  \n               data-validate=\"$numeric\" \n               data-validate-option=\"$allowEmpty; $event(type=keyup)\" \n        />\n    </div>\n    <div class=\"col-1\">\n        <a href=\"#\" class=\"pair-deleter\" id=\"";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "-delete\" title=\""
    + escapeExpression((helper = helpers.__ || (depth0 && depth0.__),options={hash:{},data:data},helper ? helper.call(depth0, "Remove pair", options) : helperMissing.call(depth0, "__", "Remove pair", options)))
    + "\"><span class=\"icon-bin\"></span></a>\n    </div>\n</div>\n";
  return buffer;
  });
});

